import { toQueryString } from '@/src/utils/generalUtils/toQueryString'

/**
 * Form SRP (Search Results Page) URL from search query object
 * @param searchQuery - The search query object
 * @returns Complete URL string for search results page
 */
export const formSrpUrl = (searchQuery: Record<string, any>): string => {
    try {
        // Determine the base pathname based on international flag
        const pathname = '/en/flights/results'
        
        // Convert search query to query string
        const queryString = toQueryString(searchQuery)
        
        // Return complete URL
        return queryString ? `${pathname}?${queryString}` : pathname
    } catch (error) {
        console.error('Error forming SRP URL:', error)
        return '/flights/results'
    }
}
